import { render, staticRenderFns } from "./WannaCoaching.vue?vue&type=template&id=a1871e14&scoped=true&"
import script from "./WannaCoaching.vue?vue&type=script&lang=js&"
export * from "./WannaCoaching.vue?vue&type=script&lang=js&"
import style0 from "./WannaCoaching.vue?vue&type=style&index=0&id=a1871e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1871e14",
  null
  
)

export default component.exports